import type { FooterProps } from './footer.types';
import Group from '@/components/landing-page/components/group';
import { defaults } from '@/components/landing-page/components/footer';
import PRIO_GROUP_TYPE from '@/components/landing-page/utils/prio-group-type';
import { cn } from '@/utils/helper';
import v1 from '@/components/landing-page/components/footer/footer-v1.module.css';
import v2 from '@/components/landing-page/components/footer/footer-v2.module.css';

const Footer = (props: FooterProps) => {
  const { groups = defaults.groups } = props;

  if (!groups.length) return null;

  return (
    <footer className={cn(v1.Footer, v2.Footer)}>
      {groups.map((group) => (
        <Group
          key={group.id}
          group={group}
          groupClassName={cn(v1.Item, v2.Item)}
          blockClassName={
            group.type === PRIO_GROUP_TYPE.CONTACT_US ? cn(v1.Contact, v2.Contact) : cn(v1.Other, v2.Other)
          }
        />
      ))}
    </footer>
  );
};

export default Footer;
